var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",style:({
    display: _vm.center ? 'flex' : 'block',
    justifyContent: _vm.center ? 'center' : null,
  })},[_c('div',{staticClass:"demo-stand",style:({
      width: _vm.width,
      transform: ("scale(" + _vm.scale + ") " + (_vm.flipToLeft ? 'rotateY(-10deg)' : 'rotateY(10deg)')),
    })},[_vm._t("demo-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }